import CoolingOffScreen from './CoolingOffScreen';

export default CoolingOffScreen;